import React from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import '../notifications-panel/notifications-panel.css'; 
import userIcon from '../../assets/images/Admin.svg';



const NotificationsPanel = ({ open, onClose, notifications = [] }) => {

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      className="notificationsPanel"
       
      PaperProps={{ className: 'mat-elevation-z4' }}
    >
<List className="notifyList"style={{ paddingTop: '80px' }}>
        {notifications.map((item, index) => (
          <ListItem key={index} className="notificationItem">
            <div className="col-2 col-sm-2 col-md-1 pl-0 float-left">
              <img src={userIcon} alt="user" />
            </div>
            <div className="col-10 col-sm-10 col-md-11 pl-0 float-right">
              <h2>{item.name}</h2>
              <p>{item.message}</p>
              <i>{item.time}</i>
            </div>
            <div className="clearfix"></div>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default NotificationsPanel;
